import { Controller, useFormContext } from "react-hook-form";
import { TipTapEditor } from "./TipTapEditor";

export interface FormTipTapEditorProps {
  name: string;
  placeholder?: string;
}

export const FormTipTapEditor = ({
  name,
  placeholder = "Enter text...",
}: FormTipTapEditorProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur } }) => (
        <TipTapEditor
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          shouldShowMenuBar
        />
      )}
    />
  );
};
